// src/hooks/hotelMealPlans/useGetHotelMealPlans.js
import { useQuery } from "@tanstack/react-query";
import { getAllHotelMealPlans } from "../../api/apiHotelMealPlans";

const QUERY_KEY = ["hotelMealPlans"];

const useGetHotelMealPlans = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllHotelMealPlans(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelMealPlans: data?.data || data?.hotelMealPlans || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetHotelMealPlans;
